export default {
    data() {
        return {
            rpp_id: 0,
            curriculum_id: 0,
            discipline_id: 0,
            rpp: {edu_prog: 0, year: 0, edu_prof: 0, curriculum: 0, discipline: 0, rpp_sample: 0},
            select_options: {edu_progs: [], years: [], edu_profs: [], curriculum: [], disciplines: [], departments: [], software: [], rpp_samples: []},
            main_info: {
                discipline: "",
                speciality: "",
                speciality_code: "01.03.02",
                profile: "",
                quality: "",
                year: "",
                edu_form: "",
                course: [],
                period: [],
                credit_mark: [],
                load: {hour: 0.0, zet: 0.0},
                creator: {fio: "Фасахов Тимур Ирикович", position: "", title: ""},
                facility: "",
                department: "",
                dep_manager: "",
                grad_dep: "",
                approval_date: "",
                protocol_num: "",
                provisor: "",
                basis: "Рабочая программа составлена на основании Федерального государственного образовательного стандарта ВО для ",
                basis_date: "",
                basis_num: "",
            },
            overload: [],
            structure: [{
                part: "",
                content: "",
                time: 0,
            }],
            text_info: {purpose: "", time: "", place: "", technology: "", eval_tool: "", literature: "", mto: "", size: "", report_text: "", inform_tech: ""},
            rpp_competitions: { UK: [], OPK_cat: [], OPK: [], PK: [], DPK: []},
            practice_type: {type: "", method: ""},
            rpp_sample: false,
        }
    },
    computed: {
        needTime: function (){
            let time = 0.0
            this.structure.forEach(theme => {
                time += parseFloat(theme.time)
            })
            return time.toFixed(1)
        },
        competition: function (){
            if (this.main_info.speciality_code.length === 6 || this.main_info.speciality_code.length === 7){
                this.rpp_competitions = {able: "", know: "", own: ""}
            }
        }
    },
    methods: {
        AddUKCompetition(){
            this.rpp_competitions.UK.push({info: {}, text: ""})
        },
        DelUKCompetition(index){
            this.rpp_competitions.UK.splice(index, 1)
        },
        AddOPKCatCompetition(){
            this.rpp_competitions.OPK_cat.push({info: {}, text: ""})
        },
        DelOPKCatCompetition(index){
            this.rpp_competitions.OPK_cat.splice(index, 1)
        },
        AddOPKCompetition(){
            this.rpp_competitions.OPK.push({name:"", text: ""})
        },
        DelOPKCompetition(index){
            this.rpp_competitions.OPK.splice(index, 1)
        },
        AddPKCompetition(){
            this.rpp_competitions.PK.push({name:"", text: ""})
        },
        DelPKCompetition(index){
            this.rpp_competitions.PK.splice(index, 1)
        },
        AddDPKCompetition(){
            this.rpp_competitions.DPK.push({name:"", text: "", control: ""})
        },
        DelDPKCompetition(index){
            this.rpp_competitions.DPK.splice(index, 1)
        },
        getControl() {
            this.main_info.load.hour = 0;
            this.main_info.credit_mark = [];
            this.main_info.period = [];
            this.main_info.course = [];
            this.overload.forEach(el => {
                if (el.load === "Зачет с оценкой"){
                    this.main_info.credit_mark.push(this.period[el.period][1]);
                }
                this.main_info.period.push(this.period[el.period][1]);
                this.main_info.course.push(this.period[el.period][0]);
                this.main_info.load.hour += el.value;
            })
            this.main_info.period = this.main_info.period.filter(this.uniq);
            this.main_info.course = this.main_info.course.filter(this.uniq);
            this.main_info.credit_mark = this.main_info.credit_mark.filter(this.uniq);
            this.main_info.credit_mark.sort();
            this.main_info.period.sort();
            this.main_info.course.sort();
            this.main_info.load.hour = parseFloat(this.main_info.load.hour).toFixed(1)
            this.main_info.load.zet = (this.main_info.load.hour / 36).toFixed(2);
        },
    }
}